import dayjs from 'dayjs';

// eslint-disable-next-line import/prefer-default-export
export const dateFixed = (date) => {
  const dateDayjs = dayjs((date))
    .add(1, 'day').toDate()
    .toISOString();
  return new Date(dateDayjs).toLocaleDateString('en-GB');
};
